import React from "react";
import { useNavigate } from "react-router-dom";


const AboutComp = (props) => {
  const { pitch } = props;
  const navigate  = useNavigate();




  return (

    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <div className="section-label">Who We Are</div>
          <h2 className="section-title">About True-Extract</h2>
          <p className="section-description">
            Trusted by legal professionals, law enforcement, and corporate investigators worldwide
          </p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p>
              <span className="highlight">True-Extract</span> is a specialized mobile forensics company dedicated to providing comprehensive data extraction and analysis services for legal, investigative, and corporate clients.
            </p>
            <p>
              Our advanced forensic methodologies ensure that every piece of digital evidence is extracted, preserved, and reported with the highest standards of integrity and chain-of-custody compliance.
            </p>
            <p>
              With years of experience in mobile device forensics, we help our clients uncover critical information from smartphones, tablets, and other mobile devices, delivering actionable insights that stand up to the most rigorous legal scrutiny.
            </p>
          </div>
          <div className="about-features">
            {/* <div className="feature-item">
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ display: "inline-block", verticalAlign: "middle", marginRight: "8px" }}>
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                Certified Expertise
              </h3>
              <p>Our forensic analysts hold industry-leading certifications and maintain strict adherence to legal and ethical standards.</p>
            </div> */}
            <div className="feature-item">
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ display: "inline-block", verticalAlign: "middle", marginRight: "8px" }}>
                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                </svg>
                Rapid Response
              </h3>
              <p>Time-sensitive cases require immediate action. We provide expedited services without compromising quality.</p>
            </div>
            <div className="feature-item">
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ display: "inline-block", verticalAlign: "middle", marginRight: "8px" }}>
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
                Secure Process
              </h3>
              <p>Military-grade encryption and secure chain-of-custody protocols protect your data at every stage.</p>
            </div>
            <div className="feature-item">
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ display: "inline-block", verticalAlign: "middle", marginRight: "8px" }}>
                  <line x1="18" y1="20" x2="18" y2="10"></line>
                  <line x1="12" y1="20" x2="12" y2="4"></line>
                  <line x1="6" y1="20" x2="6" y2="14"></line>
                </svg>
                Evidential Reports
              </h3>
              <p>Comprehensive, detailed reports formatted to meet legal requirements and expert testimony standards.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default AboutComp;




